import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


//README : Use this service for broadcasting changes from inner cards to outer step/workflow
//if it is not something that is generic for all cards, generic situations can use the interface ICardComponent

@Injectable({ providedIn: 'root' })
export class StepDetailsService {
  public needsRevisionSubject: BehaviorSubject<boolean>;
  
  public workFlowCurrentStep: BehaviorSubject<string>;
  public workFlowCode: BehaviorSubject<string>;

  
  constructor() {
    this.needsRevisionSubject = new BehaviorSubject(false);
    this.workFlowCurrentStep = new BehaviorSubject(undefined);
    this.workFlowCode = new BehaviorSubject(undefined);
  }

  public emitNeedsRevisionChange(value: boolean) {
    this.needsRevisionSubject.next(value)
  }

  public newCurrentStep(value: string) {
    //if (value !== undefined)
      this.workFlowCurrentStep.next(value)
  }

  public newWorkFlowCode(value: string): void {
    if (value !== undefined)
      this.workFlowCode.next(value)
  }


}
